@if (isVisible) {
  <div class="file-upload" [formGroup]="formGroup">
    <form-control-label [id]="controlId" [question]="componentData" [flow]="flowComponent"></form-control-label>
    <div class="grid-x">
      <div class="cell large-9 medium-9 small-8">
        <div class="checkbox">
          <label>
            <input class="show-for-sr" type="checkbox" [attr.id]="headerKey" formControlName="hasHeaders" (ngModelChange)="setHasHeaders($event)" />
            <label aria-hidden="true" [attr.for]="headerKey" class="inline">
              <span class="checkbox-box"><span class="checkbox-check">&#x2714;</span></span>
              <span class="control-label-text padding-left">Uploaded file contains column headings.</span>
            </label>
          </label>
        </div>
      </div>
      <div class="cell large-3 medium-3 small-4 text-align-right">
        <button class="button" (click)="requestSample()">Sample Format</button>
      </div>
    </div>
    @if (!disable) {
      <upload-view-files [uniqueId]="componentData.key" [componentLabel]="'Upload Formatted Document'" [isPadded]="false" (newFilesList)="parseFile($event)" [showFileList]="false" [allowDeletion]="!disable"></upload-view-files>
    } @else {
      <div class="drop-area grid-x">
        <span class="italic">
          File upload is disabled.
        </span>
      </div>
    }
    @if (hasFileListing) {
      <div class="file-list padding-all-small">
        <h3 class="minor margin-bottom h6">Uploaded Files</h3>
        @for (file of uploadedFiles; track file) {
          <div class="flex">
            <uploaded-file [allowFileDeletion]="!uploadComplete && !disable" [file]="file" (fileDeleted)="deleteFile($event)"></uploaded-file>
          </div>
        }
      </div>
    }
    <text-loader [run]="!fileRead && hasFileListing" [text]="'Reading File'" [interval]="1000" [tickType]="'.'"></text-loader>
    @if (fileRead) {
      <div class="cell bold">
        Parsed Rows:
      </div>
      @if (parsedData && parsedData.length > 0) {
        <div class="cell margin-bottom">
          <ag-grid-angular class="data-grid " [gridOptions]="parsedGridOptions" [rowData]="parsedData" aria-label="File Parser"></ag-grid-angular>
        </div>
      } @else {
        <div class="cell bold">
          File contains no valid rows.
        </div>
      }
      <div class="cell bold">
        Errors:
      </div>
      @if (errorData && errorData.length > 0) {
        <div class="cell">
          <ag-grid-angular class="data-grid " [gridOptions]="errorGridOptions" [rowData]="errorData" aria-label="File Parser"></ag-grid-angular>
        </div>
      } @else {
        <div class="cell bold">
          File contains no errors.
        </div>
      }
    }
    <a style="display:none;" #downloadLink></a>
  </div>
}




